// path: frontend/src/hooks/useMetaHelpers.js
/**
 * Удобные обёртки над GET /api/v1/meta для UI. Все хуки читают из
 * одного кэша (META_KEY, staleTime: Infinity) — дублирующих запросов
 * нет.
 *
 *   - useAllowedEmailDomains — для live-подсказки в форме логина;
 *   - useAuthorFallbackDomain — фолбэк-домен для e-mail без @ (legacy);
 *   - usePriorityOptions — {value,label}[] для select приоритета
 *     (projectPriorities / adminProjectPriorities);
 *   - usePriorityMeta — {label,color} для отображения приоритета
 *     (ProjectCard, отчёты).
 *
 * Никаких console.warn здесь нет: meta — источник правды, deprecated
 * утилиты в constants.js работают независимо для потребителей, которые
 * ещё не перешли.
 */
import { useMemo } from "react";
import { useMetaQuery } from "../api/queries/meta";

export function useAllowedEmailDomains() {
  const { data: meta } = useMetaQuery();
  return useMemo(() => meta?.allowedEmailDomains ?? [], [meta]);
}

export function useAuthorFallbackDomain() {
  const { data: meta } = useMetaQuery();
  return useMemo(() => {
    const first = meta?.allowedEmailDomains?.[0];
    return first ? first.replace(/^@/, "") : "";
  }, [meta]);
}

export function usePriorityOptions(ptype) {
  const { data: meta } = useMetaQuery();
  return useMemo(() => {
    const source =
      ptype === "admin"
        ? (meta?.adminProjectPriorities ?? {})
        : (meta?.projectPriorities ?? {});
    return Object.entries(source).map(([value, def]) => ({
      value,
      label: def.label,
    }));
  }, [ptype, meta]);
}

export function usePriorityMeta(ptype, priority) {
  const { data: meta } = useMetaQuery();
  return useMemo(() => {
    const source =
      ptype === "admin"
        ? (meta?.adminProjectPriorities ?? {})
        : (meta?.projectPriorities ?? {});
    const key = priority || "NORM";
    return source[key] ?? { label: key, color: "#64748b" };
  }, [ptype, priority, meta]);
}
